import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useTicket from "../../hooks/useTicket";
import { toast } from "react-toastify";
import { getDataFormatWithTime } from "../../utils/dateFormat";
import './detail-ticket.css'
import { faFolderOpen, faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DownloadAttachmentModal from "../../components/modals/download-attachment-modal/DownloadAttachmentModal";
import StatusCardTicket from "../../components/status-card-ticket/StatusCard";
import HistoryTicketModal from "../../components/modals/history-ticket-modal/HistoryTicketModal";
import Menucustom from "../../common/menu/menucustom";

class DetailTicket extends React.Component {
    state = {
        detailTicket: undefined,
        newComment: "",
        selectedTicket: null,
        showHistoryModal: false,
        showDownloadModal: false,
    };

    componentDidMount() {
        const ticketFromStorage = this.getSelectedTicketFromStorage();

        if (!ticketFromStorage) {
            window.location.href = "/";
            return;
        }

        this.setState({ selectedTicket: ticketFromStorage }, () => {
            this.getInfoTicket();
        });
    }

    getSelectedTicketFromStorage = () => {
        const storedTicket = sessionStorage.getItem("selectedTicket");
        if (!storedTicket) return null;

        try {
            return JSON.parse(storedTicket);
        } catch (error) {
            console.error("Errore nel parsing del ticket salvato", error);
            return null;
        }
    };

    handleChangeComment = (event) => {
        this.setState({ newComment: event.target.value });
    };

    closeInputComment = () => {
        this.setState({ newComment: "" });
    };

    getInfoTicket = () => {
        const { getTicketDetail } = this.props;
        const { selectedTicket } = this.state;

        getTicketDetail(
            selectedTicket?.id,
            (data) => {
                this.setState({ detailTicket: data });
                console.log("Dettaglio ticket:", data);
            },
            () => {
                toast.error("Errore nel ricevere i dettagli del ticket, riprova")
            }
        )
    };

    sendTicketComment = () => {
        const { updateTicketComment } = this.props;
        const { selectedTicket, newComment } = this.state;

        let ticketComment = {
            idTicket: selectedTicket.id,
            messaggio: newComment,
        }
        updateTicketComment(
            ticketComment,
            () => {
                toast.success("Commento aggiunto con successo");
                this.getInfoTicket();
                this.closeInputComment();
            },
            () => {
                toast.error("Errore nell'inserimento del commento, riprova")
            }
        )
    }

    toggleHistoryModal = () => {
        this.setState((prevState) => ({
            ...prevState,
            showHistoryModal: !prevState.showHistoryModal,
        }));
    };

    toggleDownloadModal = () => {
        this.setState((prevState) => ({
            ...prevState,
            showDownloadModal: !prevState.showDownloadModal,
        }));
    };

    renderPartStoricoTicket = () => {
        const { detailTicket, selectedTicket } = this.state;

        if(detailTicket?.stati?.length > 0){
          return <div className="d-flex flex-column w-100 gap-2">
            <div className='d-flex justify-content-between'>
              <div className='d-flex flex-column status-history-header'>
                <div className='d-flex gap-1'>
                  <b>Data caricamento:</b>
                  <p>{selectedTicket ? getDataFormatWithTime(selectedTicket.dataCreazione) : "-"}</p>
                </div>
                <div className='d-flex gap-1'>
                  <b>Matricola caricamento:</b>
                  <p>{selectedTicket ? selectedTicket.utente : "-"}</p>
                </div>
              </div>
              <Button
                variant='warning'
                className="text-white"
                onClick={
                    this.toggleHistoryModal
                }
              >
                <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter}/>
              </Button>
            </div>
            <fieldset className='d-flex status-history-body'>
              <legend className="detail-legend">Ultimo stato</legend>
              {detailTicket?.stati && <StatusCardTicket status={detailTicket?.stati[0]} showDescription={false}/>}
              {detailTicket.stati.length === 0 && <span>Non ci sono stati</span>}
            </fieldset>
            {this.state.showHistoryModal && <HistoryTicketModal statusList={detailTicket?.stati} show={this.state.showHistoryModal} onClose={this.toggleHistoryModal}/>}
          </div>
        }else{
          return <span>Nessuno storico disponibile</span>
        }
        };

    render() {
        const { navigate } = this.props;
        const { detailTicket, newComment, selectedTicket, showDownloadModal, showHistoryModal } = this.state;

        return (
            <>
            <div id="wrapper">
                <Menucustom/>
                <div className="container-fluid mb-3" style={{backgroundColor:"#eceffa"}}>
            <div className="d-sm-flex  align-items-center justify-content-between py-3">
                <div className='d-flex align-items-center gap-2'>
                    <div>
                        <Button className='text-white' variant="warning" onClick={()=>window.history.back()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-caret-left-fill" viewBox="0 0 16 16">
                            <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
                        </svg>
                        </Button>
                    </div>
                    <h1 className="mb-0 text-gray-800">
                        Dettaglio ticket
                    </h1>               
                </div>
                <div className="d-flex flex-column ms-auto flex-lg-row gap-lg-2 gap-1">
                    <Button variant="warning" onClick={this.toggleDownloadModal}>
                        <FontAwesomeIcon className='text-white me-2' icon={faFolderOpen}/>
                        Download Allegati
                    </Button>
                </div>            
            </div>
            <div className="row">
                    <div className="d-flex flex-column col-8">
                        <div className="d-flex flex-column gap-2">
                            <div className="d-flex flex-column">
                                <fieldset className="detail-fieldset gap-2">
                                    <legend className="detail-legend">Info Ticket</legend>
                                    <div>
                                        <span><b> Ticket n°:</b></span>
                                        <input
                                        className="form-control"
                                        disabled
                                        type="text"
                                        value={detailTicket ? detailTicket?.id : "Cliente non disponibile"}
                                        />
                                    </div>
                                    <div>
                                        <span><b>Data Creazione:</b></span>
                                        <input
                                        className="form-control"
                                        disabled
                                        type="text"
                                        value={detailTicket ? getDataFormatWithTime(detailTicket?.dataCreazione) : "Prodotto non disponibile"}
                                        />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div className="d-flex flex-column mt-2">
                            <div className="comment-box">
                                {detailTicket && detailTicket?.commenti?.length > 0 ? detailTicket.commenti.map((commento, index)=>(
                                    <div key={index} className={`mb-3 ${commento.tipologiaUtente === 'OPERATORE' ? 'operator-comment' : 'user-comment'}`}>
                                        <div className={`comment p-2 ${commento.tipologiaUtente === 'OPERATORE' ? 'comment-color-operator' : 'comment-color-user'}`}>
                                            <div className="d-flex justify-content-between mb-1">
                                                <b>{commento.utente}</b>
                                            </div>
                                            <div>
                                                <p>{commento.messaggio}</p>
                                            </div>
                                            <div className="d-flex justify-content-end">
                                            <small><span>{getDataFormatWithTime(new Date(commento.dataInserimento), "DD/MM/yyyy HH:mm")}</span></small> 
                                            </div>
                                        </div>

                                    </div>
                                )) : <span>Nessun commento disponibile</span>}
                            </div>
                            <div className="d-flex">
                                <input className="form-control" placeholder="Aggiungi un commento..." type="text" onChange={this.handleChangeComment} value={newComment}/>
                                <Button className="align-self-end" variant="primary" onClick={this.sendTicketComment}>Invia</Button>
                            </div>
                            

                        </div>
                    </div>
                    <div className="d-flex flex-column col-4 gap-2">
                        <div className='d-flex flex-column gap-2'>
                            <fieldset className="detail-fieldset gap-2">
                                <legend className="detail-legend">Storico Stati Ticket</legend>
                                        {this.renderPartStoricoTicket()}
                            </fieldset>
                        </div>
                        <div className='d-flex flex-column gap-2'>
                            <fieldset className="detail-fieldset gap-2">
                                <legend className="detail-legend">Info generali</legend>
                                    <div>
                                        <span><b> Categoria:</b></span>
                                        <span> {detailTicket ? detailTicket?.categoria : "Categoria non disponibile"}</span>
                                    </div>
                                    <div>
                                        <span><b> Descrizione:</b></span>
                                        <textarea
                                        className="form-control"
                                        disabled
                                        type="text"
                                        value={detailTicket ? detailTicket?.descrizione : "Descrizione non disponibile"}
                                        />
                                    </div>
                            </fieldset>
                        </div>
                    </div> 
                    <DownloadAttachmentModal show={showDownloadModal} onClose={this.toggleDownloadModal} selectedTicketDetails={detailTicket}/>       
                </div>        
        </div>
            </div>
        
        
    </>
        );
    }
}

const DetailTicketWrapper = () => {
    const { getTicketDetail, updateTicketComment, downloadAttachment } = useTicket();

    return (
        <DetailTicket
            getTicketDetail={getTicketDetail}
            updateTicketComment={updateTicketComment}
            downloadAttachment={downloadAttachment}
        />
    );
};

export default DetailTicketWrapper;
